var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.41699 4.08366H7.58366V5.25033H6.41699V4.08366ZM6.41699 6.41699H7.58366V9.91699H6.41699V6.41699ZM7.00033 1.16699C3.78033 1.16699 1.16699 3.78033 1.16699 7.00033C1.16699 10.2203 3.78033 12.8337 7.00033 12.8337C10.2203 12.8337 12.8337 10.2203 12.8337 7.00033C12.8337 3.78033 10.2203 1.16699 7.00033 1.16699ZM7.00033 11.667C4.42783 11.667 2.33366 9.57283 2.33366 7.00033C2.33366 4.42783 4.42783 2.33366 7.00033 2.33366C9.57283 2.33366 11.667 4.42783 11.667 7.00033C11.667 9.57283 9.57283 11.667 7.00033 11.667Z",
    fill: "#323232"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_729"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/INFO.c13c345f4514815cb4d0988b437ff9a2.svg";
export { ForwardRef as ReactComponent };